import React from 'react';
import { Formik, Form } from 'formik';
import FormField from '../../../components/FormField';
import LoadingOverlay from '../../../components/LoadingOverlay';
import Button from '../../../audi-ui-components/Button';
import IconForward from '../../../audi-ui-components/icons/Forward';
import { validate } from '../../../lib/validation';
import { request } from '../../../lib/apiRequestWrapper';
import Modal from '../../../audi-ui-components/Modal';
import { gtmPush } from '../../../lib/gtm';
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import QuickCheckRecalls from './QuickCheckRecalls';
import CollapsibleSection from '../../../components/CollapsibleSection';
import VINHelp from '../../Vehicles/components/VINHelp';

import {
  PATH_HOME,
  FIELD_SELECT,
  OPTS_STATES,
} from '../../../constants';

const mapStateToProps = state => {
  return {
    isAuthed: state.profile.isAuthed,
  }
}
const mapDispatchToProps = dispatch => {
  return {}
}

class QuickCheckForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      submitAttempted: false,
      serverError: false,
      showResults: false,
      recallsLoaded: false,
      recallError: false,
      summaryVinError: false,
      activeTab: 0, // 0 = rego, 1 = VIN
      roadsidePoliciesStatus: "",
      roadsidePoliciesType: "",
      warrantyPlansStatus: "",
      servicePlansStatus: "",
      variant: "",
      model: "",
      recallModelName: "",
      vin: "",
      imageUrl: "",
      recalls: [],
    }
  }

  resetState = () => {
    this.setState({
      isSubmitting: false,
      submitAttempted: false,
      serverError: false,
      showResults: false,
      recallsLoaded: false,
      recallError: false,
      summaryVinError: false,
      activeTab: 0,
      roadsidePoliciesStatus: "",
      roadsidePoliciesType: "",
      warrantyPlansStatus: "",
      servicePlansStatus: "",
      variant: "",
      model: "",
      recallModelName: "",
      vin: "",
      imageUrl: "",
      recalls: [],
    });
  }

  submitForm = (values, formikBag) => {
    if (this.state.activeTab === 0) {
      // rego path: resolve rego → VIN first, then call SummaryVIN
      request(
        `${process.env.RAZZLE_API}/2/services/vehicle/${encodeURIComponent(values.registrationNumber.trim())}/${values.regoState}`,
        { method: 'POST' }
      ).then(response => {
        if (response.vin) {
          this.callSummaryVin(response.vin, formikBag);
        } else {
          formikBag.setErrors({ registrationNumber: "We can't find a matching Audi VIN with this registration number. Please try entering the VIN directly." });
          formikBag.setSubmitting(false);
        }
      }).catch(() => {
        formikBag.setErrors({ registrationNumber: "We can't find a matching Audi VIN with this registration number. Please try entering the VIN directly." });
        formikBag.setSubmitting(false);
      });
    } else {
      this.callSummaryVin(values.vin, formikBag);
    }
  }

  callSummaryVin = (vin, formikBag) => {
    this.setState({ vin });

    // get the image in the background regardless of Nadasu outcome
    request(
      `${process.env.RAZZLE_MEDIASERVICE}/MediaServiceCache/vinimageurl`,
      {
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify({ vin, view: "n3c14aut", mimeType: "image/png", width: 120 })
      }
    ).then(response => {
      this.setState({ imageUrl: response.imageUrl });
    }).catch((error) => {
      // don't do anything on error, image simply won't appear.
      console.log('mediaservice error', error);
    });

    const fetchRecalls = () => {
      request(`${process.env.RAZZLE_API}/1/recall/${vin}`)
        .then(res => {
          this.setState({ recalls: res.recalls || [], recallsLoaded: true, recallModelName: res.modelName || "" });
        })
        .catch(() => {
          this.setState({ recallsLoaded: true, recallError: true });
        });
    };

    // get the summary details by VIN
    request(
      `${process.env.RAZZLE_API}/1/serviceplan/SummaryVIN`,
      {
        method: 'POST',
        body: JSON.stringify({ vehicle: { vin } }),
      }
    ).then((res) => {
      console.log(res);
      if (!res?.model) {
        this.setState({
          summaryVinError: true,
          roadsidePoliciesStatus: res.roadsidePoliciesStatus || "",
          roadsidePoliciesType: res.roadsidePoliciesType || "",
          warrantyPlansStatus: res.warrantyPlansStatus || "",
          servicePlansStatus: res.servicePlansStatus || "",
          isSubmitting: false,
          showResults: true,
        });
        formikBag.setSubmitting(false);
        fetchRecalls();
        return;
      }

      // we are good, set the values
      this.setState({
        variant: res.variant,
        model: res.model,
        roadsidePoliciesStatus: res.roadsidePoliciesStatus,
        roadsidePoliciesType: res.roadsidePoliciesType,
        warrantyPlansStatus: res.warrantyPlansStatus,
        servicePlansStatus: res.servicePlansStatus,
        isSubmitting: false,
        showResults: true,
      });
      formikBag.setSubmitting(false);

      fetchRecalls();

    }).catch((error) => {
      if (error.body && error.body.modelState) {
        // field-level validation errors — keep form open
        formikBag.setErrors(error.body.modelState);
        this.setState({ isSubmitting: false });
        formikBag.setSubmitting(false);
      } else {
        // other API errors — transition to results and attempt recalls
        this.setState({ isSubmitting: false, showResults: true, summaryVinError: true });
        formikBag.setSubmitting(false);
        fetchRecalls();
      }
    });
  }

  validateForm = (values) => {
    const schema = this.state.activeTab === 0
      ? {
          registrationNumber: {
            presence: { message: "Registration number is required", allowEmpty: false }
          },
          regoState: {
            presence: { message: "Please select a state", allowEmpty: false }
          },
        }
      : {
          vin: {
            presence: { message: "VIN is required", allowEmpty: false },
            format: {
              pattern: /^[A-Za-z0-9]{17}$/,
              message: "Please enter a valid VIN of 17 characters"
            }
          },
        };
    return validate(values, schema, { format: "firstError", fullMessages: false });
  }

  // on close return home
  handleCloseModal = () => {
    this.resetState();
    this.props.history.push(PATH_HOME);
  }

  render() {
    return (
      <Modal isActive modalStyle="layer" closeButton close={this.handleCloseModal} className="quick-check-modal">

        <div className="quick-check-form">
          <div className="py-7 px-small-7">
            <h1 className="aui-headline-4 mb-3"><b>QuickCheck your Audi's cover</b></h1>
            <p className="description mb-5">Enter your VIN or registration number for a quick overview of your Audi's current warranty, service plan, and roadside assistance coverage.</p>
            {/* FORM */}
            {!this.state.showResults &&
              <Formik validate={this.validateForm} onSubmit={this.submitForm} initialValues={{}}>
                {(formikBag) => (
                  <Form>

                    {this.state.isSubmitting && <LoadingOverlay />}

                    <div className="quick-check-tabs">
                      <button
                        type="button"
                        className={`tab-btn${this.state.activeTab === 0 ? ' is-active' : ''}`}
                        onClick={() => this.setState({ activeTab: 0, submitAttempted: false })}
                      >
                        Rego and state
                      </button>
                      <button
                        type="button"
                        className={`tab-btn${this.state.activeTab === 1 ? ' is-active' : ''}`}
                        onClick={() => this.setState({ activeTab: 1, submitAttempted: false })}
                      >
                        VIN
                      </button>
                    </div>

                    {this.state.activeTab === 0 && (
                      <div className="quick-check-rego-row">
                        <div className="rego-field">
                          <FormField name="registrationNumber" label="Enter your rego" formikBag={formikBag} showErrors={this.state.submitAttempted} />
                        </div>
                        <div className="state-field">
                          <FormField name="regoState" label="State" fieldType={FIELD_SELECT} options={OPTS_STATES} formikBag={formikBag} showErrors={this.state.submitAttempted} />
                        </div>
                      </div>
                    )}

                    {this.state.activeTab === 1 && (
                      <FormField name="vin" label="VIN" formikBag={formikBag} showErrors={this.state.submitAttempted} />
                    )}

                    {this.state.activeTab === 1 && (
                      <div className="help-link mb-5">
                        <CollapsibleSection
                          visibleContent={<span className="aui-textlink">Need help locating your VIN?</span>}
                          toggleOnClickVisible
                        >
                          <VINHelp />
                        </CollapsibleSection>
                      </div>
                    )}

                    <div className="form-field submit">
                      <Button
                        label="QuickCheck"
                        type="submit"
                        buttonType="primary"
                        icon={<IconForward small />}
                        iconPosition="right"
                        onClick={() => this.setState({ submitAttempted: true })}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            }

            {/* RESULTS */}
            {this.state.showResults &&
              <>
                {(this.state.model || this.state.recallModelName) &&
                  <div className="vehicle-summary pb-4">
                    {this.state.imageUrl &&
                      <div className="vehicle-image">
                        <img src={this.state.imageUrl} alt={this.state.model || this.state.recallModelName} />
                      </div>
                    }
                    <div className="vehicle-text">
                      <h2 className="aui-headline-4 mb-4"><b>{this.state.model ? this.state.variant : this.state.recallModelName}</b></h2>
                      <div>VIN: {this.state.vin}</div>
                    </div>
                  </div>
                }
                {(this.state.model || this.state.recalls.length > 0 || this.state.warrantyPlansStatus || this.state.servicePlansStatus || this.state.roadsidePoliciesStatus) &&
                  <QuickCheckRecalls recalls={this.state.recalls} isAuthed={this.props.isAuthed} recallError={this.state.recallError} />
                }
                {(this.state.summaryVinError || this.state.warrantyPlansStatus || this.state.servicePlansStatus || this.state.roadsidePoliciesStatus || this.state.roadsidePoliciesType) &&
                  <>
                    <div className="results mb-4">
                      {(this.state.summaryVinError || this.state.warrantyPlansStatus) &&
                        <div className="result pb-4">
                          <div className="title pt-4"><b>Factory or Extended Warranty</b></div>
                          {this.state.summaryVinError
                            ? <p style={{ color: 'red' }}>Quick Check is unable to retrieve Warranty data for this vehicle. Please contact your local Audi Dealer.</p>
                            : <div className="details">
                                <div className="label">Status</div>
                                <div className="value">
                                  {this.state.warrantyPlansStatus === 'Active'
                                    ? 'This vehicle has an active Warranty'
                                    : 'Vehicle does not have an active Warranty'}
                                </div>
                              </div>
                          }
                        </div>
                      }
                      {(this.state.summaryVinError || this.state.servicePlansStatus) &&
                        <div className="result pb-4">
                          <div className="title pt-4"><b>Service Plans</b></div>
                          {this.state.summaryVinError
                            ? <p style={{ color: 'red' }}>Quick Check is unable to retrieve Service Plan data for this vehicle. Please contact your local Audi Dealer.</p>
                            : <div className="details">
                                <div className="label">Status</div>
                                <div className="value">
                                  {this.state.servicePlansStatus === 'Active'
                                    ? 'Vehicle has an active Service Plan'
                                    : 'Vehicle does not have an active Service Plan'}
                                </div>
                              </div>
                          }
                        </div>
                      }
                      {(this.state.summaryVinError || this.state.roadsidePoliciesStatus) &&
                        <div className="result pb-4">
                          <div className="title pt-4"><b>Roadside Assistance</b></div>
                          {this.state.summaryVinError
                            ? <p style={{ color: 'red' }}>Quick Check is unable to retrieve Roadside Policy data for this vehicle. Please contact your local Audi Dealer.</p>
                            : <div className="details">
                                <div className="label">Status</div>
                                <div className="value">
                                  {this.state.roadsidePoliciesStatus === 'Active'
                                    ? 'Vehicle has an active Roadside Assistance policy'
                                    : 'Vehicle does not have an active Roadside Assistance policy'}
                                </div>
                              </div>
                          }
                        </div>
                      }
                    </div>
                  </>
                }
                {!this.state.model && !this.state.warrantyPlansStatus && !this.state.servicePlansStatus && !this.state.roadsidePoliciesStatus && this.state.recallsLoaded && this.state.recalls.length === 0 &&
                  <p className="server-error py-3">VIN not found. Please check and try again.</p>
                }
                {this.state.model &&
                  <div className="footnote mb-4">
                    To view full coverage details, your Audi must be registered. Please log in to myAudi with your registered vehicle to continue.
                  </div>
                }

                <div className="buttons">
                  <Link to={this.props.isAuthed ? "/" : "/login"}><Button variant="primary" className="">Login to myAudi</Button></Link>
                  <Button variant="secondary" className="" onClick={this.resetState}>Quickcheck another vehicle</Button>
                </div>
              </>
            }
          </div>
        </div>
      </Modal>
    );
  }
}

QuickCheckForm.defaultProps = {
  from: { pathname: PATH_HOME }
}

const Router = withRouter(QuickCheckForm);
export default connect(mapStateToProps, mapDispatchToProps)(Router);
